__turbopack_context__.v({
  "containerLeft": "uL3yXa_containerLeft",
  "doctorImage": "uL3yXa_doctorImage",
  "doctorModal": "uL3yXa_doctorModal",
  "greifswald": "uL3yXa_greifswald",
  "hamburg": "uL3yXa_hamburg",
  "headerTextContainer": "uL3yXa_headerTextContainer",
  "imageGridContainer": "uL3yXa_imageGridContainer",
  "maskedOverflow": "uL3yXa_maskedOverflow",
  "newsletterContainerLeft": "uL3yXa_newsletterContainerLeft",
  "newsletterHeaderTextContainer": "uL3yXa_newsletterHeaderTextContainer",
  "newsletterModal": "uL3yXa_newsletterModal",
  "studyCentersContainer": "uL3yXa_studyCentersContainer",
  "studyModal": "uL3yXa_studyModal",
  "studyModalOuter": "uL3yXa_studyModalOuter",
});
